









































































































import {
  useCountQtyDifference,
  useStockAdjustment,
} from "@/hooks/useStockAdjustment";
import MNotificationVue from "@/mixins/MNotification.vue";
import { PAGE_SIZE_OPTIONS } from "@/models/constant/global.constant";
import { DEFAULT_DATE_FORMAT } from "@/models/constants/date.constant";
import {
  FormValue,
  StockAdjustmentResponseDTO,
} from "@/models/interface/stock-adjustment";
import { ColumnDef } from "@/types";
import { Component, Mixins } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";

@Component({
  beforeRouteLeave(to, from, next) {
    this.resetStore();
    next();
  },
  computed: {
    ...mapGetters({
      form: "stockAdjStore/getForm",
      detail: "stockAdjStore/getDetail",
      isOpname: "stockAdjStore/isOpname",
    }),
  },
  methods: {
    ...mapActions({
      resetStore: "stockAdjStore/resetStore",
    }),
  },
})
export default class DetailPage extends Mixins(MNotificationVue) {
  DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;
  PAGE_SIZE_OPTIONS = PAGE_SIZE_OPTIONS;
  useCountQtyDifference = useCountQtyDifference;

  form!: FormValue;
  detail!: StockAdjustmentResponseDTO;
  isOpname!: boolean;
  resetStore!: () => void;

  columnAdj: ColumnDef[] = [
    {
      title: this.$t("lbl_part_number"),
      dataIndex: "productCode.label",
      width: "200px",
      scopedSlots: { customRender: "nullable" },
    },
    {
      title: this.$t("lbl_part_name"),
      dataIndex: "productName.label",
      width: "200px",
      scopedSlots: { customRender: "nullable" },
    },
    {
      title: this.$t("lbl_rack"),
      dataIndex: "warehouseLocation.label",
      width: "200px",
      scopedSlots: { customRender: "nullable" },
    },
    {
      title: this.$t("lbl_brand"),
      dataIndex: "productMerk",
      width: "200px",
      scopedSlots: { customRender: "nullable" },
    },
    {
      title: this.$t("lbl_type"),
      dataIndex: "type",
      width: "200px",
      scopedSlots: { customRender: "type" },
    },
    {
      title: this.$t("lbl_serial_number"),
      dataIndex: "serialNumber",
      width: "200px",
      customRender: (text: string) => text || "-",
    },
    {
      title: this.$t("lbl_qty_adjustment"),
      dataIndex: "qty",
      width: "200px",
      align: "right",
      scopedSlots: { customRender: "number" },
    },
    {
      title: this.$t("lbl_uom"),
      dataIndex: "uom.label",
      width: "200px",
    },
    {
      title: this.$t("lbl_note"),
      dataIndex: "notes",
      width: "200px",
      scopedSlots: { customRender: "nullable" },
    },
  ];

  columnOpn = [
    {
      title: this.$t("lbl_part_number"),
      dataIndex: "productCode.label",
      scopedSlots: { customRender: "nullable" },
    },
    {
      title: this.$t("lbl_part_name"),
      dataIndex: "productName.label",
      scopedSlots: { customRender: "nullable" },
    },
    {
      title: this.$t("lbl_rack"),
      dataIndex: "warehouseLocation.label",
      width: "200px",
      scopedSlots: { customRender: "nullable" },
    },
    {
      title: this.$t("lbl_serial_number"),
      dataIndex: "serialNumber",
      width: "200px",
      customRender: (text: string) => text || "-",
    },
    {
      title: this.$t("lbl_brand"),
      dataIndex: "productMerk",
      scopedSlots: { customRender: "nullable" },
    },
    {
      title: this.$t("lbl_qty_total"),
      dataIndex: "qty",
      width: "100px",
      align: "right",
      scopedSlots: { customRender: "number" },
    },
    {
      title: this.$t("lbl_uom"),
      dataIndex: "uom.label",
      width: "100px",
    },
    {
      title: this.$t("lbl_qty_physical"),
      dataIndex: "physicalQty",
      align: "right",
      scopedSlots: { customRender: "number" },
    },
    {
      title: this.$t("lbl_qty_difference"),
      dataIndex: "differenceQty",
      align: "right",
      scopedSlots: { customRender: "differenceQty" },
    },
    {
      title: this.$t("lbl_note"),
      dataIndex: "notes",
      width: "200px",
      scopedSlots: { customRender: "nullable" },
    },
  ];

  get columns() {
    return this.isOpname ? this.columnOpn : this.columnAdj;
  }

  handleBack(): void {
    this.$router.push({
      name: "logistic.stock-adjustment",
    });
  }

  showAttachment(): void {
    const { viewAttachment } = useStockAdjustment();
    viewAttachment(this.form.attachment);
  }
}
